import React from 'react';
import { useGetQuestionsFeedInfiniteQuery, useGetSoulmatesQuery } from '../../apis';
import { NavLink } from 'react-router-dom';

const RightSide: React.FC = () => {
  // Reuse the main feed query instead of a second, full `/questions` fetch.
  // RTK Query dedupes this against the Home column's subscription, so the
  // sidebar costs no extra network request — it reads the same cached pages.
  const { data, isLoading } = useGetQuestionsFeedInfiniteQuery();
  const { data: soulmatesData, isLoading: soulmatesLoading, error: soulmatesError } = useGetSoulmatesQuery({ limit: 10 });

  // Render whatever feed pages are cached. We intentionally do NOT bail on the
  // feed query's `error`: now that this shares Home's infinite query, a failed
  // `fetchNextPage()` (triggered by scrolling Home) surfaces as an error even
  // though earlier pages are cached — and that must not blank the sidebar or
  // the independently-loaded soulmates below.
  const limitedQuestions = data?.pages.flat().slice(0, 5) ?? [];

  return (
    <div className="flex-1 max-w-[450px] pb-app-base">
      <div>
        {isLoading && limitedQuestions.length === 0 ? (
          <p>Loading....</p>
        ) : limitedQuestions.length === 0 ? (
          <p>No questions found</p>
        ) : (
          limitedQuestions.map((question) => (
            <NavLink to={`/question/${question.questionId}`} key={`RightSideNavlinkTo${question.questionId}`}>
              <p>{question.title}</p>
            </NavLink>
          ))
        )}
      </div>

      {/* Soulmates Section */}
      <div className="mt-8">
        <h3 className="text-lg font-semibold mb-4 text-app-white">Soulmates</h3>
        {soulmatesLoading ? (
          <p className="text-app-gray">Loading soulmates...</p>
        ) : soulmatesError ? (
          <p className="text-app-gray">Unable to load soulmates</p>
        ) : soulmatesData?.soulmates && soulmatesData.soulmates.length > 0 ? (
          <div>
            {soulmatesData.soulmates.map((soulmate) => (
              <NavLink 
                to={`/profile/${soulmate._id}`} 
                key={`RightSideSoulmate${soulmate._id}`}
                className="block mb-2 hover:opacity-80"
              >
                <div className="flex items-center justify-between">
                  <p className="text-app-white">
                    {soulmate.displayName || soulmate.userName}
                  </p>
                  <span className="text-app-gray text-sm">
                    {soulmate.matchScore}%
                  </span>
                </div>
              </NavLink>
            ))}
          </div>
        ) : (
          <p className="text-app-gray">No soulmates found</p>
        )}
      </div>
    </div>
  );
};

export default RightSide;
